module.exports = __webpack_public_path__ + "static/media/logo.34cb099b.svg";